import React from 'react';
import { connect } from 'react-redux';

import { Button } from 'apps/auth/components/common/Button/Button';
import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import PreCheckMainView from 'apps/auth/components/ga/accounts/send/precheck/PreCheckMainView';
import CheckTableRow from 'apps/auth/components/history/send/cheque/units/CheckTableRow';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { getDDMonEEEHHmmDate } from 'apps/auth/helpers/utils';
import { useAuth, useCheck, useLanguage } from 'apps/auth/hooks/selectors';
import { CheckService } from 'apps/auth/services/CheckService';

const PlaidCheque = (props) => {
    const cheque = useCheck();
    const { countryId: userCountry } = useAuth();
    const { lang } = useLanguage();
    const precheck = props.precheck;
    const messages = props.messages;
    const exchangeText = precheck.exchangeRate || props.exchangeRatioText;
    const date = new Date().toString();

    const getHeader = () => {
        return (
            <>
                <Row indent="adaptive-16-24">
                    <PreCheckMainView preCheck={precheck} messages={props.messages} />
                    <Row flex align="center">
                        <Icon name="clock" rightIndent="16px" />
                        {props.chequePlaidStatus}
                    </Row>
                </Row>
            </>
        );
    };

    const getDateFeeRateUnit = () => {
        return (
            <>
                <Separator marginTop="16px" />
                <TableContainer>
                    <CheckTableRow title={props.chequeBlockDate} titleColor="secondary" textColor="primary" cheque={cheque}>
                        {getDDMonEEEHHmmDate(date, lang)}
                    </CheckTableRow>
                    <CheckTableRow title={props.precheckAmountFee} titleColor="secondary" textColor="primary" cheque={cheque}>
                        {precheck.commission}
                    </CheckTableRow>
                    {exchangeText && (
                        <CheckTableRow title={props.precheckAmountFxRate} titleColor="secondary" textColor="primary" cheque={cheque}>
                            <Row flex align="center">
                                {exchangeText}
                            </Row>
                        </CheckTableRow>
                    )}
                </TableContainer>
            </>
        );
    };

    const RecipientDetails = () => {
        return (
            <>
                <Separator marginTop="16px" />
                <TableContainer>
                    {precheck.nameTo && precheck.nameTo.trim().length > 0 && (
                        <CheckTableRow title={props.chequeRecipientHeader} titleColor="secondary" textColor="primary" cheque={cheque}>
                            {precheck.nameTo}
                        </CheckTableRow>
                    )}
                    <CheckTableRow title={props.toBlock} titleColor="secondary" textColor="primary" cheque={cheque}>
                        {CheckService.getFormattedDeliveryAccount(messages, precheck.deliveryMethod, userCountry, props.toCountry.id, precheck.accountTo)}
                    </CheckTableRow>
                </TableContainer>
            </>
        );
    };

    const PaymentInfo = () => {
        return (
            <>
                <Separator />
                <TableContainer>
                    <CheckTableRow title={props.chequeBlockPayment} titleColor="secondary" textColor="primary" cheque={cheque}>
                        {props.bankName}
                    </CheckTableRow>
                </TableContainer>
            </>
        );
    };

    return (
        <ModalComponent canCloseModal={false}>
            {getHeader()}
            {getDateFeeRateUnit()}
            {RecipientDetails()}
            {props.bankName && PaymentInfo()}
            <FixedBottomPanel isRightAligned>
                <Button type={'link'} raised="true" href={'/auth/pay/status/request?id=' + precheck.id} caption={props.continue} />
            </FixedBottomPanel>
        </ModalComponent>
    );
};

const mapStateToProps = (state) => ({
    messages: state.messages.pageMessages,
    precheck: state.extra.precheck,
    continue: state.messages.pageMessages.continue,
    exchangeRatioText: state.extra.exchangeRatioText,
    precheckAmountFxRate: state.messages.pageMessages.precheckAmountFxRate,
    precheckAmountFee: state.messages.pageMessages.precheckAmountFee,
    toBlock: state.messages.pageMessages.toBlock,
    chequeRecipientHeader: state.messages.pageMessages.chequeRecipientHeader,
    chequeBlockBankHeader: state.messages.pageMessages.chequeBlockBankHeader,
    chequeBlockPayment: state.messages.pageMessages.chequeBlockBankHeader,
    toCountry: state.extra.toCountry,
    chequeBlockDate: state.messages.pageMessages.chequeBlockDate,
    chequePlaidStatus: state.messages.pageMessages.chequePlaidStatus,
});

export default connect(mapStateToProps, null)(PlaidCheque);
